function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .vt0{fill:none;stroke:#6E7276;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "vt0",
  x1: 5.7,
  y1: 9.2,
  x2: 24.7,
  y2: 9.2
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "vt0",
  x1: 5.7,
  y1: 15.2,
  x2: 24.7,
  y2: 15.2
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "vt0",
  x1: 5.7,
  y1: 21.2,
  x2: 24.7,
  y2: 21.2
});

var SvgListViewInactive = function SvgListViewInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "list block",
    id: "Layer_15",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListViewInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_view_inactive.726696e6.svg";
export { ForwardRef as ReactComponent };